import { Report, ReportFile } from "./constants";

export const GET_REPORTS = "report/reports/GET_REPORT";
export const GET_REPORTS_FAILURE = "report/GET_REPORT_FAILURE";

export const ADD_REPORTS = "report/reports/ADD_REPORT";
export const ADD_REPORT_FILES = "report/files/ADD_REPORT_FILES";

export const DELETE_REPORT = "report/reports/DELETE_REPORT";
export const DELETE_REPORT_FAILURE = "report/reports/DELETE_REPORT_FAILURE";

export const GET_REPORT_FILES = "report/files/GET_REPORT_FILES";
export const GET_REPORT_FILES_FAILURE = "report/files/GET_REPORT_FILES_FAILURE";

export const RESEND_REPORT_FILE = "report/files/RESEND_REPORT_FILE";
export const RESEND_REPORT_FILE_FAILURE =
  "report/files/RESEND_REPORT_FILE_FAILURE";

export const SEND_LATEST_REPORT = "report/files/SEND_LATEST_REPORT";
export const SEND_LATEST_REPORT_FAILURE =
  "report/files/SEND_LATEST_REPORT_FAILURE";

export const FLUSH_REPORTS = "report/reports/FLUSH_REPORTS";
export const FLUSH_REPORT_FILES = "report/reports/FLUSH_REPORT_FILES";

export const SELECT_MERCHANT = "report/SELECT_MERCHANT";

export const flushReports = () => ({
  type: FLUSH_REPORTS
});

export const flushReportFiles = () => ({
  type: FLUSH_REPORT_FILES
});

export const getReportFiles = (merchant_id: number) => ({
  type: GET_REPORT_FILES,
  payload: merchant_id
});

export const addReportFiles = (files: ReportFile[]) => ({
  type: ADD_REPORT_FILES,
  payload: files
});

export const getReportFilesFailure = () => ({
  type: GET_REPORT_FILES_FAILURE
});

export const getReports = (merchant_id: number) => ({
  type: GET_REPORTS,
  payload: merchant_id
});

export const addReports = (reports: Report[]) => ({
  type: ADD_REPORTS,
  payload: reports
});

export const deleteReport = (
  merchant_id: number,
  report_id: number,
  report_name: string
) => ({
  type: DELETE_REPORT,
  payload: { merchant_id, report_id, report_name }
});

export const resendReportFile = (
  merchant_id: number,
  report_id: number,
  report_file_id: number
) => ({
  type: RESEND_REPORT_FILE,
  payload: { merchant_id, report_id, report_file_id }
});

export const resendReportFileFailure = () => ({
  type: RESEND_REPORT_FILE_FAILURE
});

export const sendLatestReport = (merchant_id: number, report_id: number) => ({
  type: SEND_LATEST_REPORT,
  payload: { merchant_id, report_id }
});

export const sendLatestReportFailure = () => ({
  type: SEND_LATEST_REPORT_FAILURE
});

export const deleteReportFailure = () => ({
  type: DELETE_REPORT_FAILURE
});

export const getReportsFailure = () => ({
  type: GET_REPORTS_FAILURE
});

export const selectMerchant = (merchant_id: number) => ({
  type: SELECT_MERCHANT,
  payload: { merchant_id }
});



// WEBPACK FOOTER //
// ./client/modules/Report/actions.ts